var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var DataPickerArrow = function DataPickerArrow(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 8 13' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'Data-picker-arrow'
      ),
      React.createElement('path', { d: 'M7.954 6.248L.995 12.999 0 12.037l5.928-5.751L.014.957 1.008 0l5.911 5.325 1.035.923', fill: 'currentColor', fillRule: 'evenodd'
      })
    )
  );
};
/*eslint-enable */

export default DataPickerArrow;
//# sourceMappingURL=DataPickerArrow.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/DataPickerArrow.js